export const NetworkStatus = {
  Online: "online",
  Offline: "offline",
};
